import ListActions from "modules/list/actions";

import { JobSchema } from "utils/schemas";

export const JOBS_MODULE = "clusterGroupJobs";

export const jobsListingActions = new ListActions({
  async fetchData({ namespaces = [], clusters = [] } = {}) {
    //TODO
    return {
      items: [],
    };
  },
  initialQuery: () => ({
    namespaces: [],
    clusters: [],
  }),
  schema: [JobSchema],
});
